/* unplugin-vue-components disabled */import script from "./ExpressDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpressDetails.vue?vue&type=script&setup=true&lang=js"

import "./ExpressDetails.vue?vue&type=style&index=0&id=159debcc&lang=scss"

const __exports__ = script;

export default __exports__